import { TmBaseError } from '@/core/error/tmBaseError'

export class TmWistiaUnavailableError extends TmBaseError {
  public name = 'TmWistiaUnavailableError'

  public shouldBeMonitored(): boolean {
    return false
  }
}
